module.exports = __webpack_public_path__ + "img/composer-attach.adcc1698.svg";